import React from "react";

import Link from "components/shared/Link/Link";
import TourPage from "components/shared/Tour/TourPage";
/* Custom: ensure that this imports only the custom TourSlider */
import TourSlider from "./TourSlider";

import localize from "lang/localize";

class CustomTourPage extends TourPage {
  /* Custom: ensure that this imports only the custom TourSlider */
  renderTourSlider() {
    return (
      <TourSlider
        tourScreens={this.props.tourScreens}
        completedTour={this.props.completedTour}
        setCompletedTour={this.props.setCompletedTour}
        handleCloseClick={this.props.handleCloseClick}
        language={this.props.language}
      />
    );
  }

  /* Custom: changed copy of 'continue' button */
  render() {
    return (
      <div className="container verticalpadding relative tour-interface">
        <button
          onClick={e => this.props.handleCloseClick(e)}
          className="close-button-container"
        >
          <i className="fa close-button" aria-hidden="true" />
        </button>
        <div className="innerblock flex flex-direction-column justify-content-center">
          <div className="pure-g">
            <div className="pure-u-1 pure-u-sm-1-12" />
            <div className="pure-u-1 pure-u-sm-5-6 bottommargin">
              {this.renderTourSlider()}
            </div>
            <div className="pure-u-1 pure-u-sm-1-12" />
          </div>
          <div className="pure-g tour-cta-container">
            <div className="pure-u-1 flex justify-content-center">
              {this.props.completedTour ? (
                <Link
                  to={this.props.redirectUrl}
                  className="button cta nomargin"
                  id="tourLinkContinue"
                  onClick={e => this.props.handleCloseClick(e)}
                >
                  {localize("lets_go_text", this.props.language)}
                </Link>
              ) : (
                <Link
                  to={this.props.redirectUrl}
                  className="button lowercase nomargin"
                  id="tourLinkSkip"
                  onClick={e => this.props.handleCloseClick(e)}
                >
                  {localize("button_tour_skip", this.props.language)}
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomTourPage;
